<template>
  <div class="container">
    <div style="float: left">
      <img src="../../assets/flags/icons/Fridge.png" />
    </div>
    <div style="float: left">
      <h4 v-if="storageName != null">{{ $t(storageName) }}</h4>
      <h6>{{ $t("storage.numberOfProducts") }} {{ counterIngredients }}</h6>
    </div>
    <Button class="nav-button" type="button" @click="storeStorageItemState">
      <i class="pi pi-angle-right" style="font-size: 2rem"></i>
    </Button>
  </div>
</template>

<script>
export default {
  props: {
    storageItemInfo: Object,
  },
  data() {
    return {
      storageName: null,
      counterIngredients: null,
    };
  },
  methods: {
    storeStorageItemState() {
      this.$store.commit(
        "storage/setActiveStorageId",
        this.storageItemInfo.storageType.id
      );
      this.$store.commit("storage/setVisibleStorage", this.storageItemInfo);
      this.goToSignleStorage();
    },
    goToSignleStorage() {
      this.$router.push({
        name: "singleStorage",
        params: { type: this.storageName.toLowerCase() },
      });
    },
  },
  computed: {},
  mounted() {
    this.storageName = this.storageItemInfo.storageType.key;
    this.counterIngredients = this.storageItemInfo.ingredients.length;
  },
};
</script>

<style scoped>
.container {
  height: 120px;
  background: #fafafa;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  padding-top: 20px;
  padding-bottom: 14px;
  padding-right: 5%;
  padding-left: 5%;
  margin-bottom: 20px;
}

h6 {
  font-weight: 400;
  margin-top: 1rem;
}

.nav-button {
  float: right;
  width: 58px;
  height: 58px;
  margin-top: 12px;
}
</style>
